import { render, staticRenderFns } from "./v-navbar-menu.vue?vue&type=template&id=67b07988&scoped=true&"
var script = {}
import style0 from "./v-navbar-menu.vue?vue&type=style&index=0&id=67b07988&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b07988",
  null
  
)

export default component.exports